import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { TenantService } from '../services/tenant.service';

// Die URL ist die einzige Quelle des Mandanten: der Routen-Parameter :tenantId enthaelt den
// Mandantennamen. Der Guard uebertraegt ihn (inkl. nachgeladener Mandanten-ID) in den
// TenantService dieses Tabs, bevor Resolver und Komponenten laufen. Dadurch kann ein
// Mandantenwechsel in einem anderen Browser-Tab diesen Tab nicht mehr beeinflussen.
@Injectable({ providedIn: 'root' })
export class RoutingGuardTenant  {

  constructor(public tenantService: TenantService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const urlTenantName = route.paramMap.get('tenantId') ?? '';

    return this.tenantService.activateTenantFromUrl(urlTenantName).pipe(
      // kein (bestaetigter) Mandant dieses Namens fuer den Benutzer -> zurueck zur Mandantenauswahl
      map((isValid: boolean) => isValid ? true : this.router.createUrlTree(['/', 'select-tenant']))
    );
  }
}
